import {type Theme, type Components} from "../..";
import {segmentControlButtonClasses} from "../../../components/SegmentControlButton";

type SegmentControlButtonOverrides = Components<Theme>["MuiSegmentControlButton"];

const overrides: SegmentControlButtonOverrides = {
    styleOverrides: {
        root: ({theme}) => ({
            borderRadius: theme.borderRadius.full,

            /**
             * Specific focus-visible styles due to markup structure
             */
            "&::before": {
                content: "''",
                position: "absolute",
                width: "calc(100% + 6px)",
                height: "calc(100% + 6px)",
                border: `1.5px solid transparent`,
                borderRadius: "inherit",
            },
            [`&:has(.${segmentControlButtonClasses.input}:focus-visible)`]: {
                "&::before": {
                    border: `1.5px solid ${theme.color.border.focused}`,
                    outline: `1.5px solid ${theme.color.border.inverted.strong}`,
                    outlineOffset: -3,
                },
            },
            [`& .${segmentControlButtonClasses.checked}`]: {
                boxShadow: theme.shadows[4],
            },
        }),
        label: ({theme}) => ({
            color: theme.color.text.subtle,
            transition: theme.transitions.create(["color"], {
                duration: theme.transitions.duration.short,
                easing: theme.transitions.easing.easeInOut,
            }),

            [`.${segmentControlButtonClasses.checked} &, .${segmentControlButtonClasses.root}:hover &`]:
                {
                    color: theme.color.text.default,
                },
        }),
    },
    defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
    },
};

export default overrides;
